import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { white, MQ } from '@css/constants'

const HEADER_HEIGHT = '64px'

export const AccordionNavWrapper = styled('nav')(css`
  background: ${white};
  margin-top: ${HEADER_HEIGHT};
  z-index: 100;

  ${MQ.SMALL_SCREENS} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: calc(100vh - ${HEADER_HEIGHT});
    width: 100%;
    max-width: 414px;
    margin-left: auto;
    margin-right: auto;
    overflow-y: auto;
    z-index: 1111;
  }
`)

export const ButtonsWrapper = styled('div')(css`
  margin: 15px 10px 120px 10px;
  display: flex;
  flex-direction: column;
`)

export const getMyQuoteBtnStyles = css`
  margin-bottom: 10px;
  width: 100%;
`

export const lockStyles = css`
  ${MQ.SMALL_SCREENS} {
    .lock {
      overflow: hidden;
    }
  }
`
